var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "50px",
    viewBox: "0 0 51 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-220.000000, -944.000000)",
    stroke: "#A17D58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7131746,33.2925677 L44.2655556,27.3730839 C45.9655556,26.4154065 48.1584127,26.9883097 49.1393651,28.6481806 C50.1211111,30.3072774 49.5338095,32.4479226 47.8338095,33.4056 L32.4290476,41.9720516 C31.7115873,42.3707613 30.8996825,42.5805677 30.0734921,42.5805677 L18.3790476,42.5805677 C17.5163492,42.5805677 16.6695238,42.8089548 15.9314286,43.2425032 L13.0957143,44.9023742",
    id: "Stroke-1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0434127,34.8386323 L30.1711905,34.8386323 C32.1354762,34.8386323 33.7418254,33.2716645 33.7418254,31.3555355 L33.7418254,31.3516645 C33.7418254,29.4370839 32.1362698,27.8708903 30.1735714,27.8708903 L17.2307143,27.8708903 C16.3584921,27.8708903 15.5029365,28.105471 14.7569048,28.5483097 L6.77515873,33.2902452",
    id: "Stroke-3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    points: "0.408492063 34.0652129 4.37357143 31.7426323 13.8886508 46.4492129 11.5196032 47.9999226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4409524,27.8973677 C35.4798413,26.2498839 37.71,19.3549161 37.71,19.3549161 C37.71,19.3549161 24.6465079,19.4284645 25.8052381,27.8710452",
    id: "Stroke-7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.410873,27.8708903 C23.2037302,20.9991484 12.313254,21.6773419 12.313254,21.6773419 C12.313254,21.6773419 13.3910317,25.2432774 15.7680159,28.105471",
    id: "Stroke-9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3292063,9.29024516 C35.3292063,14.4208258 31.0649206,18.5805677 25.8053968,18.5805677 C20.545873,18.5805677 16.2815873,14.4208258 16.2815873,9.29024516 C16.2815873,4.15966452 20.545873,-7.7419355e-05 25.8053968,-7.7419355e-05 C31.0649206,-7.7419355e-05 35.3292063,4.15966452 35.3292063,9.29024516 Z",
    id: "Stroke-11",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8053968,18.5805677 L25.8053968,26.3225032",
    id: "Stroke-13",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6307143,12.3870194 C23.4243651,13.9354065 25.0116667,13.9354065 25.0116667,13.9354065 L26.5989683,13.9354065 C27.9084921,13.9354065 28.9799206,12.8902452 28.9799206,11.6128258 C28.9799206,10.3354065 27.9084921,9.29024516 26.5989683,9.29024516 L25.0116667,9.29024516 C23.7021429,9.29024516 22.6307143,8.24508387 22.6307143,6.96766452 C22.6307143,5.69024516 23.7021429,4.64508387 25.0116667,4.64508387 L26.5989683,4.64508387 C26.5989683,4.64508387 28.1862698,4.64508387 28.9799206,6.19347097",
    id: "Stroke-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8053968,13.9354065 L25.8053968,15.4837935",
    id: "Stroke-19",
    strokeLinecap: "round"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon7);
export default __webpack_public_path__ + "static/media/product-icon7.eb97dde299201be00949214b2d0b97a0.svg";
export { ForwardRef as ReactComponent };